module.exports = __webpack_public_path__ + "static/media/18ECA10.a3edd24d.jpg";